import { SupportFolderSchema } from "@redotech/redo-support-common/support-folder";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getSupportFolderById = {
  name: "getSupportFolderById" as const,
  input: z.object({ folderId: zExt.objectId() }),
  output: SupportFolderSchema.nullable(),
};
